import React, { useEffect, useState } from 'react';
import { ArrowPathIcon } from '@heroicons/react/24/outline';
import apiClient from '../../services/apiClient';

const GlobalLoadingOverlay: React.FC = () => {
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        // Subscribe to loading state changes
        const unsubscribe = apiClient.subscribeToLoading((loading) => {
            setIsLoading(loading);
        });

        return () => {
            unsubscribe();
        };
    }, []);

    if (!isLoading) {
        return null;
    }

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/30 backdrop-blur-[1px] transition-all duration-300">
            <div className="bg-white rounded-2xl shadow-xl p-8 flex flex-col items-center justify-center animate-in fade-in zoom-in duration-200">
                <div className="relative mb-4">
                    <div className="absolute inset-0 bg-primary-100 rounded-full animate-ping opacity-75"></div>
                    <div className="relative bg-primary-50 rounded-full p-4">
                        <ArrowPathIcon className="w-10 h-10 text-primary-600 animate-spin" />
                    </div>
                </div>
                <h3 className="text-lg font-semibold text-gray-900">Processing...</h3>
                <p className="text-sm text-gray-500 mt-1">Please wait while we fetch your data</p>
            </div>
        </div>
    );
};

export default GlobalLoadingOverlay;
